module.exports = __webpack_public_path__ + "img/Security1_CN@3x.f9607841.png";